import Worker from 'worker-loader!./worker';
import PromiseWorker from 'promise-worker';
let worker, promiseWorker, postMessage = false
try {
worker = new Worker();
promiseWorker = new PromiseWorker(worker);
postMessage = message => promiseWorker.postMessage(message);
}
catch(err) {
console.log(err)
}
export default {
  postMessage
};
